/*!
 * staff-ecommerce · Asistente «asistente de staff-ecommerce» · widget del tema (vanilla, sin dependencias)
 *
 * Seguridad y privacidad:
 *  - El texto del modelo se pinta SIEMPRE como texto (createTextNode). Nunca innerHTML.
 *  - Solo se vuelven enlaces los de staff-ecommerce.com y los canales fijos de contacto
 *    (hola@staff-ecommerce.com y las páginas legales del sitio; no hay WhatsApp publicado).
 *  - El historial vive solo en sessionStorage (se borra al cerrar la pestaña). Nada en localStorage.
 *  - Correos y números largos se tapan en el navegador antes de enviar.
 *
 * Configuración (atributos del <script>):
 *   data-staff-endpoint    URL del POST /api/staff (obligatorio)
 *   data-staff-css         URL de staff-asistente.css (el botón aparece recién con los estilos cargados)
 *   data-staff-cara        URL de la foto de staff-ecommerce (96 px)
 *   data-staff-privacidad  URL de la sección del asistente en la política de privacidad
 *   data-staff-whatsapp    número de WhatsApp internacional, sin + (por defecto el de la tienda)
 */
(function () {
  'use strict';
  var G = typeof window !== 'undefined' ? window : globalThis;

  var CORREO = 'hola@staff-ecommerce.com';
  var WA_POR_DEFECTO = '5491164082843';
  var MAX_CAMPO = 400;
  var CLAVE_SESION = 'staff-asistente:v1';
  var PRIVACIDAD_POR_DEFECTO = 'https://staff-ecommerce.com/policies/privacy-policy';
  var RE_FIRMA = /^[A-Za-z0-9_-]{22}$/;

  /* ======================= Funciones puras (se prueban en Node) ======================= */

  var car = String.fromCharCode;
  function claseRegex(pares, cuantificador) {
    var s = '[';
    for (var i = 0; i < pares.length; i++) {
      s += pares[i].length > 1 ? car(pares[i][0]) + '-' + car(pares[i][1]) : car(pares[i][0]);
    }
    return new RegExp(s + ']' + (cuantificador || ''), 'g');
  }
  var RE_INVISIBLES = claseRegex([[0x00, 0x08], [0x0b], [0x0c], [0x0e, 0x1f], [0x7f, 0x9f], [0xad], [0x200b, 0x200f], [0x202a, 0x202e], [0x2060, 0x206f], [0xfeff]]);
  var RE_ESPACIOS = claseRegex([[0x09], [0x20], [0xa0], [0x2000, 0x200a], [0x202f], [0x3000]], '+');

  function normalizar(valor) {
    var t = String(valor == null ? '' : valor);
    if (t.normalize) t = t.normalize('NFC');
    return t
      .replace(/\r\n?/g, '\n')
      .replace(RE_INVISIBLES, '')
      .replace(RE_ESPACIOS, ' ')
      .replace(/ *\n */g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function ocultarDatos(texto) {
    var n = 0;
    var t = String(texto)
      .replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, function (m) {
        if (m.toLowerCase() === CORREO) return m;
        n++;
        return '[correo omitido]';
      })
      .replace(/\+?\d(?:[ .-]?\d){7,}/g, function () {
        n++;
        return '[número omitido]';
      });
    return { texto: t, ocultos: n };
  }

  /* Rutas de la tienda que pueden volverse enlace: inicio, fichas, colecciones, páginas, carrito y
     políticas. Nada de /account, /cart/clear, /cart/add, /checkout, /search ni archivos (.js, .json). */
  var RE_RUTA_TIENDA = /^\/(?:(?:products|collections|pages|policies)\/[a-z0-9][a-z0-9-]{0,79}|cart)?$/;

  /** Devuelve { href, texto, externo } si el enlace es de los permitidos; si no, null. */
  function enlaceSeguro(crudo, wa) {
    wa = wa || WA_POR_DEFECTO;
    if (typeof crudo !== 'string' || !crudo || crudo.length > 300) return null;
    if (crudo.toLowerCase() === CORREO) return { href: 'mailto:' + CORREO, texto: CORREO, externo: true };
    if (crudo.length > 1 && RE_RUTA_TIENDA.test(crudo)) {
      return { href: 'https://staff-ecommerce.com' + crudo, texto: 'staff-ecommerce.com' + crudo, externo: false };
    }
    var u;
    try {
      u = new URL(crudo);
    } catch (e) {
      return null;
    }
    if (u.protocol !== 'https:' || u.username || u.password || u.port) return null;
    var host = u.hostname.toLowerCase();
    if (host === 'staff-ecommerce.com' || host === 'www.staff-ecommerce.com') {
      // new URL ya resolvió «..» y «%2e%2e»: se controla la ruta final, sin la consulta (?…).
      var camino = u.pathname.length > 1 ? u.pathname.replace(/\/$/, '') : u.pathname;
      if (!RE_RUTA_TIENDA.test(camino)) return null;
      var ruta = camino + (/^#[A-Za-z0-9_-]{1,40}$/.test(u.hash) ? u.hash : '');
      return { href: 'https://staff-ecommerce.com' + ruta, texto: 'staff-ecommerce.com' + (ruta === '/' ? '' : ruta), externo: false };
    }
    // No hay WhatsApp publicado en esta tienda: un wa.me en la respuesta no se muestra.
    if (host === 'botanica-maestro-staff.netlify.app' && /^\/legales\/[a-z0-9-]+\.html$/.test(u.pathname)) {
      return { href: 'https://botanica-maestro-staff.netlify.app' + u.pathname, texto: 'botanica-maestro-staff.netlify.app' + u.pathname, externo: true };
    }
    return null;
  }

  var RE_CANDIDATO = /(https?:\/\/[^\s<>"'«»()\[\]{}]+|hola@staff-ecommerce\.com|\/(?:products|pages|collections|policies)\/[a-z0-9][a-z0-9-]{0,79}|\/cart(?![A-Za-z0-9_\/-]|\.[A-Za-z0-9]))/gi;

  /** Parte un texto en trozos de texto y de enlaces permitidos. Lo demás queda como texto. */
  function trocear(texto, wa) {
    var s = String(texto == null ? '' : texto);
    var partes = [];
    var ultimo = 0;
    var m;
    RE_CANDIDATO.lastIndex = 0;
    while ((m = RE_CANDIDATO.exec(s)) !== null) {
      var crudo = m[0];
      var inicio = m.index;
      if (crudo.charAt(0) === '/' && inicio > 0 && /[A-Za-z0-9\/.:_-]/.test(s.charAt(inicio - 1))) continue;
      var limpio = crudo.replace(/[.,;:!?…»"')]+$/, '');
      var e = enlaceSeguro(limpio, wa);
      if (!e) continue;
      if (inicio > ultimo) partes.push({ t: 'texto', v: s.slice(ultimo, inicio) });
      partes.push({ t: 'enlace', v: e.texto, href: e.href, externo: e.externo });
      ultimo = inicio + limpio.length;
    }
    if (ultimo < s.length) partes.push({ t: 'texto', v: s.slice(ultimo) });
    return partes;
  }

  /**
   * A qué altura va el botón (px desde el piso de la pantalla) para no tapar controles del sitio.
   * obstaculos: [{ top, bottom, peso }] en coordenadas de la pantalla, ya filtrados a la columna del botón.
   * o: { alto (innerHeight), tam (lado del botón), minimo (piso sin obstáculos), techo (top mínimo), aire, actual }.
   * Si llega actual (la página se está desplazando) y ahí no tapa nada, se queda: no salta sin necesidad.
   * Si no, prueba el piso mínimo y, en orden, justo encima de cada obstáculo; devuelve el primero que no se
   * superpone con ninguno sin pasar el techo. Si ninguno entra, el de menos peso tapado (a igualdad, el más bajo).
   */
  function elegirPiso(obstaculos, o) {
    var aire = o.aire == null ? 8 : o.aire;
    function tapa(piso) {
      var abajo = o.alto - piso;
      var n = 0;
      for (var j = 0; j < obstaculos.length; j++) {
        if (obstaculos[j].bottom > abajo - o.tam - aire && obstaculos[j].top < abajo + aire) n += obstaculos[j].peso || 1;
      }
      return n;
    }
    function cabe(piso) {
      return o.alto - piso - o.tam >= o.techo;
    }
    if (o.actual != null && o.actual >= o.minimo && cabe(o.actual) && !tapa(o.actual)) return o.actual;
    var candidatos = [o.minimo];
    for (var i = 0; i < obstaculos.length; i++) {
      var c = Math.ceil(o.alto - obstaculos[i].top + aire);
      if (c > o.minimo) candidatos.push(c);
    }
    candidatos.sort(function (a, b) {
      return a - b;
    });
    var mejor = o.minimo;
    var menos = Infinity;
    for (var k = 0; k < candidatos.length && cabe(candidatos[k]); k++) {
      var n = tapa(candidatos[k]);
      if (!n) return candidatos[k];
      if (n < menos) {
        menos = n;
        mejor = candidatos[k];
      }
    }
    return mejor;
  }

  if (G.__STAFF_PRUEBAS__ || typeof document === 'undefined') {
    G.__staffPruebas = { normalizar: normalizar, ocultarDatos: ocultarDatos, enlaceSeguro: enlaceSeguro, trocear: trocear, elegirPiso: elegirPiso };
    return;
  }

  /* ======================= Configuración ======================= */

  var script = document.currentScript || document.querySelector('script[data-staff-endpoint]');
  var ds = (script && script.dataset) || {};

  function urlSegura(valor, permitirLocal) {
    if (!valor) return null;
    try {
      var u = new URL(valor, G.location.href);
      if (u.protocol === 'https:') return u.href;
      if (permitirLocal && u.protocol === 'http:' && (u.hostname === '127.0.0.1' || u.hostname === 'localhost')) return u.href;
    } catch (e) {}
    return null;
  }

  var CFG = {
    endpoint: urlSegura(ds.staffEndpoint, true),
    css: urlSegura(ds.staffCss, true),
    cara: urlSegura(ds.staffCara, true),
    privacidad: urlSegura(ds.staffPrivacidad, false) || PRIVACIDAD_POR_DEFECTO,
    wa: /^\d{10,15}$/.test(ds.staffWhatsapp || '') ? ds.staffWhatsapp : WA_POR_DEFECTO
  };
  if (!CFG.endpoint || G.__staffIniciado) return;
  G.__staffIniciado = true;

  var T = {
    abrir: 'Abrir el chat con el asistente de staff-ecommerce (asistente con IA)',
    cerrarBoton: 'Cerrar el chat con el asistente de staff-ecommerce',
    bienvenida:
      'Hola. Soy el asistente con IA de staff-ecommerce. Te ayudo a elegir curso y te cuento qué trae cada uno, cuánto sale, cómo se paga y cómo te llega. No compartas datos personales en este chat. Si preferís hablar con una persona, escribinos a hola@staff-ecommerce.com.',
    aviso:
      'Asistente con IA: puede equivocarse. No compartas datos personales: tus mensajes los procesa Google (Gemini), fuera de la Argentina, y pueden usarse para mejorar sus servicios. ',
    sugerencias: ['¿Qué curso me conviene?', '¿Cómo me llega el curso?', '¿Hay descuento si llevo dos?'],
    errorRed:
      'No pude conectarme. Probá de nuevo en un momento, o escribinos a hola@staff-ecommerce.com y te responde una persona.',
    notaDatos: 'Por tu privacidad tapamos correos y números largos antes de enviar. Para temas de un pedido, escribinos a hola@staff-ecommerce.com.',
    waMensaje: 'Hola, vengo del chat de la web de staff-ecommerce.'
  };

  var ICONOS = {
    correo:
      'M3 5.5h18v13H3v-13Zm0 0 9 6.5 9-6.5',
    globo: 'M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H10l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z',
    cruz: 'M6 6l12 12M18 6L6 18',
    enviar: 'M3.4 20.6 21.5 12 3.4 3.4 3.4 10.1 16 12 3.4 13.9z',
    whatsapp:
      'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z'
  };

  /* ======================= Utilidades del DOM ======================= */

  function h(etiqueta, atributos, hijos) {
    var el = document.createElement(etiqueta);
    if (atributos) {
      for (var k in atributos) {
        if (!Object.prototype.hasOwnProperty.call(atributos, k) || atributos[k] == null) continue;
        if (k === 'texto') el.textContent = atributos[k];
        else if (k === 'clase') el.className = atributos[k];
        else el.setAttribute(k, atributos[k]);
      }
    }
    if (hijos) for (var i = 0; i < hijos.length; i++) if (hijos[i]) el.appendChild(hijos[i]);
    return el;
  }

  function icono(d, clase) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (clase) svg.setAttribute('class', clase);
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', d);
    svg.appendChild(p);
    return svg;
  }

  function pintarTexto(el, texto) {
    var partes = trocear(texto, CFG.wa);
    for (var i = 0; i < partes.length; i++) {
      var p = partes[i];
      if (p.t === 'enlace') {
        var a = document.createElement('a');
        a.href = p.href;
        a.textContent = p.v;
        if (p.externo) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }
        el.appendChild(a);
      } else {
        el.appendChild(document.createTextNode(p.v));
      }
    }
  }

  /* ======================= Estado ======================= */

  function mensajeValido(m) {
    return (
      !!m &&
      (m.rol === 'usuario' || m.rol === 'staff' || m.rol === 'nota') &&
      typeof m.texto === 'string' &&
      m.texto.length > 0 &&
      m.texto.length <= 1500 &&
      (m.firma === undefined || RE_FIRMA.test(m.firma))
    );
  }
  function leerSesion() {
    try {
      var j = JSON.parse(G.sessionStorage.getItem(CLAVE_SESION) || 'null');
      if (j && j.v === 1 && Array.isArray(j.m)) {
        return j.m.filter(mensajeValido).slice(-30).map(function (m) {
          return { rol: m.rol, texto: m.texto, firma: m.firma };
        });
      }
    } catch (e) {}
    return [];
  }
  function guardarSesion() {
    try {
      G.sessionStorage.setItem(CLAVE_SESION, JSON.stringify({ v: 1, m: mensajes.slice(-30) }));
    } catch (e) {}
  }

  var mensajes = leerSesion();
  var abierto = false;
  var minimizadoPorVentana = false;
  var focoEraCampo = false;
  var ocupado = false;
  var subida = 0; // piso del botón en px: capas fijas del sitio y controles que no puede tapar
  var subidaFija = 0; // solo las capas fijas: aviso de cookies, barra de compra, sello de hCaptcha
  var raizHtml = document.documentElement;
  var raiz, fab, sonda, panel, cabecera, cuerpo, lista, sugerencias, escribiendo, campo, enviarBtn, contador;

  /* ======================= Posición y convivencia con el sitio ======================= */

  /* Controles que el botón no tapa nunca, ni mientras se baja (medidos el 14/9 en las 8 fichas, el inicio y el
     carrito): galería (miniaturas, puntos, flechas y sonido del video), barra fija y bloque de compra, aviso de
     cookies y botones del carrito. Se cuida todo el control; si es ancho o alto, su centro, que es donde se toca. */
  var SELECTOR_EVITAR = [
    '.gp-minis button', '.gp-puntos button', '.gp-ctrl', '.gp-sonido',
    '[data-ficha-barra] a[href]', '[data-ficha-barra] button', '#ok-cookies', '.aviso-cookies a[href]',
    '#comprar-ficha button', '#comprar-ficha a[href]', '#comprar-ficha input:not([type=hidden])', '#comprar-ficha select',
    '[data-agregar]', '[data-pagar]', '[data-mas]', '[data-menos]', '[data-quitar]', '[data-q]', '[data-whatsapp]', '[data-cupon]',
    '#checkout', '.quantity__button', 'cart-remove-button a', 'cart-remove-button button'
  ].join(',');
  /* Con la página quieta, además, cualquier otro control a la vista (puntos de la portada, enlaces del pie…):
     de esos se cuida el punto donde se toca, el centro ± 10 px. Mientras se desplaza no cuentan, así el botón
     no salta con cada enlace que pasa. */
  var SELECTOR_TOQUE = 'a[href],button,input:not([type=hidden]),select,textarea,summary,label,[role=button],[role=link],[role=tab],[role=radio],[tabindex]:not([tabindex="-1"]),video[controls]';
  var PESO_LISTA = 1000; // antes tapar varios controles comunes que uno de la lista
  var QUIETA_MS = 160;
  var AIRE = 8;
  var ultimoDesplazamiento = 0;
  var esperaQuieta = null;

  function baseBoton() {
    return G.innerWidth >= 640 ? 20 : 16;
  }
  function tamBoton() {
    return G.innerWidth >= 640 ? 60 : 56;
  }
  function margenesSeguros() {
    var cs = sonda ? G.getComputedStyle(sonda) : null;
    return { arriba: (cs && parseFloat(cs.paddingTop)) || 0, abajo: (cs && parseFloat(cs.paddingBottom)) || 0 };
  }
  function pisoMinimo() {
    return baseBoton() + margenesSeguros().abajo;
  }
  /** Con el chat abierto el botón se oculta y la tarjeta ocupa su lugar: solo sube sobre las capas fijas. */
  function pisoTarjeta() {
    return Math.max(pisoMinimo(), subidaFija);
  }
  function topeEncabezado() {
    if (document.querySelector('header.top')) return 155 + 12; // encabezado de la tienda con la cinta visible
    var d = document.querySelector('.section-header, header');
    if (d) {
      var r = d.getBoundingClientRect();
      return Math.max(0, Math.min(r.bottom, 180)) + 12;
    }
    return 12;
  }
  function altoTarjeta() {
    return Math.min(560, G.innerHeight - pisoTarjeta() - topeEncabezado());
  }
  function modoHoja() {
    return G.innerWidth < 640 || altoTarjeta() < 420;
  }
  function esHoja() {
    return panel.classList.contains('staff-panel--hoja');
  }

  /** Capas fijas sobre las que sube el botón: barra de compra, aviso de cookies y sello de hCaptcha. */
  function subidaPorCapas(vh, c) {
    var sube = 0;
    var barra = document.querySelector('[data-ficha-barra]');
    if (barra && barra.classList.contains('ver') && G.getComputedStyle(barra).display !== 'none') sube = barra.offsetHeight + 12;
    var ok = document.getElementById('ok-cookies');
    var candidatos = [ok && ok.parentElement, document.getElementById('shop-hcaptcha-badge-container'), document.getElementById('shopify-pc__banner')];
    for (var i = 0; i < candidatos.length; i++) {
      var el = candidatos[i];
      if (!el || el === document.body || el === raizHtml) continue;
      var cs = G.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) <= 0.05 || !r.width || !r.height) continue;
      if (r.top >= vh || r.bottom <= vh - 260 || r.right <= c.left || r.left >= c.right) continue;
      sube = Math.max(sube, Math.ceil(vh - r.top) + 12);
    }
    return sube;
  }

  /** Recorta con los contenedores que cortan su contenido (una miniatura corrida fuera de la tira, el sonido de otro video). */
  function recortar(el, r) {
    var t = r.top;
    var b = r.bottom;
    var l = r.left;
    var d = r.right;
    for (var p = el.parentElement, n = 0; p && p !== document.body && p !== raizHtml && n < 12; p = p.parentElement, n++) {
      var cs = G.getComputedStyle(p);
      if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
        var q = p.getBoundingClientRect();
        if (cs.overflowX !== 'visible') {
          l = Math.max(l, q.left);
          d = Math.min(d, q.right);
        }
        if (cs.overflowY !== 'visible') {
          t = Math.max(t, q.top);
          b = Math.min(b, q.bottom);
        }
        if (l >= d || t >= b) return null;
      }
      if (cs.position === 'fixed') break;
    }
    return { top: t, bottom: b, left: l, right: d };
  }

  /** ¿El centro del control recibe el toque (sin contar el chat)? Descarta recortados, ocultos y tapados por el sitio. */
  function aLaVista(el, x, y) {
    var pila = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [document.elementFromPoint(x, y)];
    for (var i = 0; i < pila.length; i++) {
      if (pila[i] && !raiz.contains(pila[i])) return pila[i] === el || el.contains(pila[i]);
    }
    return false;
  }

  /** Controles del sitio a la vista en la columna del botón, como franjas { top, bottom, peso } de la pantalla.
      quieta: suma cualquier control común (SELECTOR_TOQUE), con peso 1 y solo el centro ± 10 px. */
  function obstaculos(izq, der, vw, vh, quieta) {
    var salida = [];
    var nodos = document.querySelectorAll(SELECTOR_EVITAR);
    var t = tamBoton();
    if (quieta) {
      var comunes = document.querySelectorAll(SELECTOR_TOQUE);
      for (var k = 0; k < comunes.length && k < 3000; k++) {
        var c = comunes[k];
        var q = c.getBoundingClientRect();
        if (q.width < 1 || q.height < 1 || q.right <= izq || q.left >= der || q.bottom <= 0 || q.top >= vh) continue;
        var partes = c.getClientRects(); // enlace partido en renglones: se toca en el renglón más grande
        if (partes.length > 1) {
          q = partes[0];
          for (var p = 1; p < partes.length; p++) if (partes[p].width * partes[p].height > q.width * q.height) q = partes[p];
        }
        var x = (q.left + q.right) / 2;
        var y = (q.top + q.bottom) / 2;
        if (Math.min(q.right, x + 10) <= izq || Math.max(q.left, x - 10) >= der || x < 0 || x >= vw || y < 0 || y >= vh) continue;
        if (raiz.contains(c) || c.matches(SELECTOR_EVITAR) || (c.closest && c.closest('[inert]')) || !aLaVista(c, x, y)) continue;
        salida.push({ top: Math.max(q.top, y - 10), bottom: Math.min(q.bottom, y + 10), peso: 1 });
      }
    }
    for (var i = 0; i < nodos.length && i < 300; i++) {
      var el = nodos[i];
      var r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) continue;
      var cx = (r.left + r.right) / 2;
      var cy = (r.top + r.bottom) / 2;
      var nucleo = {
        left: r.width > 2 * t ? cx - t : r.left,
        right: r.width > 2 * t ? cx + t : r.right,
        top: r.height > 2 * t ? cy - t : r.top,
        bottom: r.height > 2 * t ? cy + t : r.bottom
      };
      if (nucleo.right <= izq || nucleo.left >= der) continue;
      if (raiz.contains(el) || (el.closest && el.closest('[inert]'))) continue;
      if (G.getComputedStyle(el).visibility !== 'visible') continue;
      var v = recortar(el, nucleo);
      if (!v || v.right <= izq || v.left >= der || v.bottom <= 0 || v.top >= vh) continue;
      salida.push({ top: v.top, bottom: v.bottom, peso: PESO_LISTA });
    }
    return salida;
  }

  /** Sube el botón sobre las capas fijas y sobre los controles que quedarían debajo. Mientras la página se desplaza
      solo cuentan los de SELECTOR_EVITAR y, si donde está no tapa ninguno, no se mueve; con la página quieta
      (QUIETA_MS sin desplazar) cuenta cualquier control a la vista. */
  function calcularSubida() {
    var vh = G.innerHeight;
    var vw = raizHtml.clientWidth || G.innerWidth;
    var c = fab.getBoundingClientRect();
    var falta = ultimoDesplazamiento + QUIETA_MS - Date.now();
    var quieta = falta <= 0;
    if (!quieta && !esperaQuieta) {
      esperaQuieta = setTimeout(function () {
        esperaQuieta = null;
        programar();
      }, falta + 20);
    }
    subidaFija = subidaPorCapas(vh, c);
    var techo = Math.max(topeEncabezado(), margenesSeguros().arriba + 12);
    var piso = elegirPiso(obstaculos(c.left - AIRE, c.right + AIRE, vw, vh, quieta), {
      alto: vh,
      tam: tamBoton(),
      minimo: Math.max(pisoMinimo(), subidaFija),
      techo: techo,
      aire: AIRE,
      actual: quieta ? null : subida
    });
    if (piso !== subida) {
      subida = piso;
      fab.style.setProperty('--staff-sube', piso + 'px');
    }
  }

  function capaAbierta(selector) {
    var e = document.querySelector(selector);
    return !!(e && e.classList.contains('abierto'));
  }

  function actualizarOculto() {
    var sitio = capaAbierta('#drawer') || capaAbierta('#panel-menu') || capaAbierta('#oferta-modal');
    var dawn = /(^|\s)overflow-hidden(-tablet|-mobile)?(\s|$)/.test(document.body.className);
    var ventana = capaAbierta('#popup');
    // Con el chat abierto el botón no se ve: la hoja o la tarjeta ocupan su lugar y tienen su propia ×.
    fab.classList.toggle('staff-fab--oculto', sitio || dawn || ventana || abierto);
    if (abierto && !esHoja()) {
      // La ventana del 5 % (z 100) se abre sola y taparía la tarjeta (z 76): se minimiza la
      // tarjeta, el foco pasa a la ventana y, cuando se cierra, la charla vuelve con lo escrito.
      if (ventana) minimizarPorVentana();
      // Carrito, menú u oferta abiertos sobre la tarjeta de escritorio: se minimiza y conserva la charla.
      else if (sitio || dawn) cerrar(false);
    } else if (!abierto && minimizadoPorVentana && !ventana) {
      minimizadoPorVentana = false;
      if (!sitio && !dawn) abrir({ foco: focoEraCampo ? 'campo' : 'cabecera' });
    }
  }

  function minimizarPorVentana() {
    var activo = document.activeElement;
    var focoAdentro = !!(activo && panel.contains(activo));
    focoEraCampo = activo === campo;
    minimizadoPorVentana = true;
    cerrar(false);
    if (!focoAdentro) return;
    // Sin esto el foco quedaba en un campo tapado y, con Escape, en BODY.
    var v = document.getElementById('popup');
    if (!v) return;
    if (!v.hasAttribute('tabindex')) v.setAttribute('tabindex', '-1');
    try {
      v.focus({ preventScroll: true });
    } catch (e) {
      v.focus();
    }
  }

  function posicionarTarjeta(recalcularAlto) {
    panel.style.top = '';
    panel.style.bottom = pisoTarjeta() + 'px';
    if (recalcularAlto) panel.style.height = altoTarjeta() + 'px';
  }

  function ajustarHoja() {
    var vv = G.visualViewport;
    panel.style.bottom = 'auto';
    if (!vv) {
      panel.style.top = '';
      panel.style.height = '';
      return;
    }
    panel.style.top = Math.round(vv.offsetTop + 12) + 'px';
    panel.style.height = Math.round(vv.height - 12) + 'px';
  }

  function ponerModo(hoja) {
    panel.classList.toggle('staff-panel--hoja', hoja);
    panel.classList.toggle('staff-panel--tarjeta', !hoja);
    raizHtml.classList.toggle('staff-hoja', hoja);
    if (hoja) ajustarHoja();
    else posicionarTarjeta(true);
  }

  function aplicarModo() {
    if (!abierto) return;
    var hoja = modoHoja();
    ponerModo(hoja);
    // Sin consultas, la bienvenida se ve entera desde arriba. Si en una ventana de escritorio baja no
    // entra en la tarjeta, se abre la hoja, que tiene más alto.
    if (!hoja && !hayConsultas()) {
      irAlInicio();
      if (!bienvenidaEntera()) ponerModo(true);
    }
  }

  var pendiente = false;
  function programar() {
    if (pendiente || !fab) return;
    pendiente = true;
    (G.requestAnimationFrame || setTimeout)(function () {
      pendiente = false;
      calcularSubida();
      actualizarOculto();
      if (abierto && !esHoja()) posicionarTarjeta(false);
    });
  }

  /* ======================= Mensajes ======================= */

  function burbuja(m) {
    if (m.rol === 'nota') return h('p', { clase: 'staff-msg staff-msg--nota', texto: m.texto });
    var el = h('div', { clase: 'staff-msg staff-msg--' + (m.rol === 'usuario' ? 'usuario' : 'staff') });
    el.appendChild(h('span', { clase: 'staff-sr', texto: m.rol === 'usuario' ? 'Vos: ' : 'staff-ecommerce: ' }));
    if (m.rol === 'usuario') el.appendChild(document.createTextNode(m.texto));
    else pintarTexto(el, m.texto);
    return el;
  }

  function bajarLista() {
    cuerpo.scrollTop = cuerpo.scrollHeight;
  }
  function irAlInicio() {
    cuerpo.scrollTop = 0;
  }
  /** Sin consultas, arriba (la bienvenida entera); con consultas, en el último mensaje. */
  function acomodarLista() {
    if (hayConsultas()) bajarLista();
    else irAlInicio();
  }
  function bienvenidaEntera() {
    var b = lista.firstChild;
    if (!b) return true;
    var z = cuerpo.getBoundingClientRect();
    var r = b.getBoundingClientRect();
    return r.top >= z.top - 1 && r.bottom <= z.bottom + 1;
  }

  function pintarTodo() {
    lista.textContent = '';
    lista.appendChild(burbuja({ rol: 'staff', texto: T.bienvenida }));
    for (var i = 0; i < mensajes.length; i++) lista.appendChild(burbuja(mensajes[i]));
    sugerencias.hidden = hayConsultas();
    acomodarLista();
  }

  function hayConsultas() {
    for (var i = 0; i < mensajes.length; i++) if (mensajes[i].rol === 'usuario') return true;
    return false;
  }

  function agregar(m) {
    mensajes.push(m);
    if (mensajes.length > 30) mensajes = mensajes.slice(-30);
    guardarSesion();
    lista.appendChild(burbuja(m));
    sugerencias.hidden = hayConsultas();
    bajarLista();
  }

  /** Últimos turnos para el servidor: sin notas, sin respuestas sin firma y dentro de ~7 KB. */
  function historialParaEnviar() {
    var salida = [];
    var bytes = 0;
    var cod = G.TextEncoder ? new TextEncoder() : null;
    for (var i = mensajes.length - 1; i >= 0 && salida.length < 8; i--) {
      var m = mensajes[i];
      if (m.rol === 'nota' || (m.rol === 'staff' && !m.firma)) continue;
      var item = m.rol === 'staff' ? { rol: 'staff', texto: m.texto, firma: m.firma } : { rol: 'usuario', texto: m.texto.slice(0, MAX_CAMPO) };
      var peso = (cod ? cod.encode(item.texto).length : item.texto.length * 3) + 60;
      if (salida.length && bytes + peso > 7000) break;
      bytes += peso;
      salida.unshift(item);
    }
    while (salida.length && salida[0].rol !== 'usuario') salida.shift();
    return salida;
  }

  function paginaActual() {
    var p = (G.location.pathname || '/').replace(/\/+$/, '') || '/';
    var m = p.match(/\/(products|collections|pages)\/([a-z0-9][a-z0-9-]{0,79})$/);
    if (m) return '/' + m[1] + '/' + m[2];
    return p === '/' || p === '/cart' ? p : undefined;
  }

  function actualizarEnviar() {
    enviarBtn.disabled = ocupado || !normalizar(campo.value);
  }

  function ajustarCampo() {
    campo.style.height = 'auto';
    campo.style.height = Math.min(120, Math.max(48, campo.scrollHeight + 2)) + 'px';
    var largo = campo.value.length;
    contador.hidden = largo < 320;
    contador.textContent = largo + '/' + MAX_CAMPO;
  }

  function enviar(crudo) {
    if (ocupado) return;
    var texto = normalizar(crudo);
    texto = Array.from ? Array.from(texto).slice(0, MAX_CAMPO).join('') : texto.slice(0, MAX_CAMPO);
    if (!texto) return;
    var od = ocultarDatos(texto);
    agregar({ rol: 'usuario', texto: od.texto });
    if (od.ocultos) agregar({ rol: 'nota', texto: T.notaDatos });
    campo.value = '';
    ajustarCampo();
    ocupado = true;
    actualizarEnviar();
    var avisoEscribiendo = setTimeout(function () {
      escribiendo.hidden = false;
      bajarLista();
    }, 300);
    var ctrl = G.AbortController ? new AbortController() : null;
    var corte = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, 25000);

    fetch(CFG.endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ v: 1, mensajes: historialParaEnviar(), pagina: paginaActual() }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null;
          try {
            j = JSON.parse(t);
          } catch (e) {}
          return { estado: r.status, j: j };
        });
      })
      .then(
        function (res) {
          var j = res.j;
          if (j && typeof j.texto === 'string' && j.texto && j.texto.length <= 1500) {
            var firma = res.estado === 200 && typeof j.firma === 'string' && RE_FIRMA.test(j.firma) ? j.firma : undefined;
            agregar({ rol: 'staff', texto: j.texto, firma: firma });
          } else {
            agregar({ rol: 'staff', texto: T.errorRed });
          }
        },
        function () {
          agregar({ rol: 'staff', texto: T.errorRed });
        }
      )
      .then(function () {
        clearTimeout(avisoEscribiendo);
        clearTimeout(corte);
        escribiendo.hidden = true;
        ocupado = false;
        actualizarEnviar();
      });
  }

  /* ======================= Abrir y cerrar ======================= */

  function abrir(opciones) {
    if (abierto) return;
    abierto = true;
    minimizadoPorVentana = false;
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    fab.setAttribute('aria-label', T.cerrarBoton);
    raizHtml.classList.add('staff-abierto');
    pintarTodo();
    aplicarModo();
    actualizarOculto();
    actualizarEnviar();
    var destino = opciones && opciones.foco === 'campo' ? campo : cabecera;
    try {
      destino.focus({ preventScroll: true });
    } catch (e) {
      destino.focus();
    }
    if (destino === campo) {
      try {
        campo.setSelectionRange(campo.value.length, campo.value.length);
      } catch (e) {}
    }
    acomodarLista();
  }

  function cerrar(devolverFoco) {
    if (!abierto) return;
    abierto = false;
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    fab.setAttribute('aria-label', T.abrir);
    raizHtml.classList.remove('staff-abierto', 'staff-hoja');
    calcularSubida(); // vuelve ya en el lugar correcto, sin tapar controles
    actualizarOculto();
    if (devolverFoco !== false) {
      try {
        fab.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function enfocables() {
    var nodos = panel.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
    var r = [];
    for (var i = 0; i < nodos.length; i++) {
      var n = nodos[i];
      if (n.offsetWidth || n.offsetHeight || n.getClientRects().length) r.push(n);
    }
    return r;
  }

  /* ======================= Montaje ======================= */

  function montar() {
    if (document.getElementById('staff-fab')) return;
    raiz = h('div', { clase: 'staff-raiz' });

    fab = h(
      'button',
      {
        id: 'staff-fab',
        clase: 'staff-fab',
        type: 'button',
        'aria-label': T.abrir,
        'aria-haspopup': 'dialog',
        'aria-expanded': 'false',
        'aria-controls': 'staff-panel'
      },
      [
        CFG.cara
          ? h('img', { clase: 'staff-fab__cara', src: CFG.cara, alt: '', width: '60', height: '60', decoding: 'async' })
          : h('span', { clase: 'staff-fab__inicial', 'aria-hidden': 'true', texto: 'C' }),
        h('span', { clase: 'staff-fab__globo', 'aria-hidden': 'true' }, [icono(ICONOS.globo)])
      ]
    );

    cabecera = h('div', { clase: 'staff-cab', tabindex: '-1' }, [
      CFG.cara ? h('img', { clase: 'staff-cab__cara', src: CFG.cara, alt: '', width: '40', height: '40', decoding: 'async' }) : null,
      h('div', { clase: 'staff-cab__textos' }, [
        h('h2', { id: 'staff-titulo', clase: 'staff-cab__titulo' }, [
          document.createTextNode('Asistente de staff-ecommerce'),
          h('span', { clase: 'staff-cab__ia', texto: ' · Asistente con IA' })
        ]),
        h('p', { clase: 'staff-cab__marca', texto: 'Cursos en PDF' })
      ]),
      h('button', { clase: 'staff-cerrar', type: 'button', 'aria-label': 'Cerrar el chat' }, [icono(ICONOS.cruz, 'staff-ico--trazo')])
    ]);

    var aviso = h('p', { id: 'staff-aviso', clase: 'staff-aviso' }, [
      document.createTextNode(T.aviso),
      h('a', { href: CFG.privacidad, target: '_blank', rel: 'noopener', texto: 'Política de privacidad' })
    ]);

    lista = h('div', { clase: 'staff-msgs', role: 'log', 'aria-live': 'polite', 'aria-relevant': 'additions', 'aria-label': 'Conversación con el asistente' });

    escribiendo = h('p', { clase: 'staff-escribiendo', 'aria-live': 'polite' }, [
      h('i', { 'aria-hidden': 'true' }),
      h('i', { 'aria-hidden': 'true' }),
      h('i', { 'aria-hidden': 'true' }),
      document.createTextNode(' staff-ecommerce está escribiendo…')
    ]);
    escribiendo.hidden = true;

    sugerencias = h('div', { clase: 'staff-sugerencias', role: 'group', 'aria-label': 'Preguntas sugeridas' });
    T.sugerencias.forEach(function (s) {
      var b = h('button', { clase: 'staff-sugerencia', type: 'button', texto: s });
      b.addEventListener('click', function () {
        enviar(s);
      });
      sugerencias.appendChild(b);
    });

    var pie = h('div', { clase: 'staff-pie' }, [
      h('a', { clase: 'staff-wa', href: 'mailto:' + CORREO + '?subject=' + encodeURIComponent('Consulta desde la web de staff-ecommerce') }, [
        icono(ICONOS.correo),
        document.createTextNode('Hablar con una persona')
      ]),
      h('a', { clase: 'staff-correo', href: 'mailto:' + CORREO, texto: CORREO })
    ]);

    campo = h('textarea', {
      id: 'staff-campo',
      clase: 'staff-campo',
      rows: '1',
      maxlength: String(MAX_CAMPO),
      placeholder: 'Escribí tu consulta…',
      autocomplete: 'off',
      enterkeyhint: 'send',
      'aria-describedby': 'staff-aviso'
    });
    contador = h('span', { clase: 'staff-contador', 'aria-hidden': 'true' });
    contador.hidden = true;
    enviarBtn = h('button', { clase: 'staff-enviar', type: 'submit', 'aria-label': 'Enviar consulta' }, [icono(ICONOS.enviar)]);
    var form = h('form', { clase: 'staff-form', novalidate: 'novalidate' }, [
      h('label', { clase: 'staff-sr', for: 'staff-campo', texto: 'Tu consulta para el asistente' }),
      h('div', { clase: 'staff-campo-caja' }, [campo, contador]),
      enviarBtn
    ]);

    // La charla y las sugerencias comparten la zona que se desplaza: así la bienvenida entra entera.
    cuerpo = h('div', { clase: 'staff-cuerpo' }, [lista, sugerencias]);

    panel = h('div', { id: 'staff-panel', clase: 'staff-panel staff-panel--tarjeta', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'staff-titulo' }, [
      cabecera,
      aviso,
      cuerpo,
      escribiendo,
      pie,
      form
    ]);
    panel.hidden = true;
    sonda = h('span', { clase: 'staff-sonda', 'aria-hidden': 'true' });

    raiz.appendChild(fab);
    raiz.appendChild(panel);
    raiz.appendChild(sonda);
    document.body.appendChild(raiz);

    /* Eventos */
    fab.addEventListener('click', function () {
      if (abierto) cerrar();
      else abrir();
    });
    cabecera.querySelector('.staff-cerrar').addEventListener('click', function () {
      cerrar();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      enviar(campo.value);
    });
    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        enviar(campo.value);
      }
    });
    campo.addEventListener('input', function () {
      ajustarCampo();
      actualizarEnviar();
    });
    campo.addEventListener('focus', function () {
      // Con el teclado abierto se muestra el último mensaje; sin consultas, la bienvenida sigue arriba.
      setTimeout(function () {
        if (hayConsultas()) bajarLista();
      }, 350);
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = enfocables();
      if (!f.length) return;
      var primero = f[0];
      var ultimo = f[f.length - 1];
      var activo = document.activeElement;
      if (e.shiftKey && (activo === primero || activo === cabecera || !panel.contains(activo))) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && (activo === ultimo || !panel.contains(activo))) {
        e.preventDefault();
        primero.focus();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (abierto && (e.key === 'Escape' || e.key === 'Esc')) {
        e.preventDefault();
        cerrar();
      }
    });

    // Dónde va el botón se recalcula al desplazar la página o una tira (en captura), al cambiar el tamaño,
    // al cargar imágenes y estilos, al terminar transiciones (galería, barra) y cuando cambia el aviso.
    document.addEventListener(
      'scroll',
      function () {
        ultimoDesplazamiento = Date.now();
        programar();
      },
      { capture: true, passive: true }
    );
    document.addEventListener('load', programar, true);
    document.addEventListener('transitionend', programar, true);
    document.addEventListener('animationend', programar, true);
    G.addEventListener('pageshow', programar);
    if (G.ResizeObserver) new ResizeObserver(programar).observe(document.body);
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', programar);
    G.addEventListener('resize', function () {
      programar();
      aplicarModo();
    });
    if (G.visualViewport) {
      var alCambiarVista = function () {
        if (abierto && esHoja()) ajustarHoja();
        programar();
      };
      G.visualViewport.addEventListener('resize', alCambiarVista);
      G.visualViewport.addEventListener('scroll', alCambiarVista);
    }

    if (G.MutationObserver) {
      var observadas = [];
      var obsAtributos = new MutationObserver(programar);
      var observarCapas = function () {
        ['[data-ficha-barra]', '#drawer', '#panel-menu', '#popup', '#oferta-modal'].forEach(function (s) {
          var e = document.querySelector(s);
          if (e && observadas.indexOf(e) < 0) {
            observadas.push(e);
            obsAtributos.observe(e, { attributes: true, attributeFilter: ['class', 'style'] });
          }
        });
      };
      obsAtributos.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      // El aviso de cookies pone en <html> la clase con-aviso-cookies y la variable --aviso-cookies.
      obsAtributos.observe(raizHtml, { attributes: true, attributeFilter: ['class', 'style'] });
      observarCapas();
      new MutationObserver(function (cambios) {
        for (var i = 0; i < cambios.length; i++) {
          if (!raiz.contains(cambios[i].target)) {
            observarCapas();
            programar();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    calcularSubida();
    actualizarOculto();
    // Por si los estilos del tema o la galería terminan de armarse después de montar el botón.
    [300, 900, 1600, 3200, 6500].forEach(function (ms) {
      setTimeout(programar, ms);
    });
  }

  function cargarCss(listo) {
    if (!CFG.css || document.querySelector('link[data-staff-css]')) return listo();
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = CFG.css;
    l.setAttribute('data-staff-css', '');
    // Sin estilos no se muestra nada: nunca un botón suelto sin formato.
    l.onload = function () {
      listo();
    };
    document.head.appendChild(l);
  }

  function arrancar() {
    var ir = function () {
      cargarCss(montar);
    };
    if (G.requestIdleCallback) G.requestIdleCallback(ir, { timeout: 1200 });
    else setTimeout(ir, 1);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
